import React from 'react';
// Import only one local image
import mainPassionImage from '../assets/SiteImages/ATXPlantRescueImage3.jpg'; // Using Sample2.jpg as the single image

function Passion() {
  return (
    <section className="bg-[#CAD3D0] text-[#1A3C34] py-20 px-6" id="whyus">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12">
        
        {/* Left Image (now a single image) */}
        <div className="relative flex justify-center w-full lg:w-1/2">
          {/* Purple Circle Badge - Still commented out as per your input */}
          {/* If you want to include this badge, uncomment it and adjust its positioning
              relative to the single image. You might need to make its positioning absolute
              relative to this parent div. */}
          {/* <div className="absolute -top-6 -left-6 z-10 flex flex-col items-center text-center">
            <div className="bg-[#E0DBF7] text-[#6B46C1] text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
              <span className="block">Your</span>
              <span className="block">Journey</span>
            </div>
          </div> */}

          {/* Single Image container - Adjusted for central alignment and potentially larger size */}
          {/* Increased size for a single image, added shadow and hover effect for better design */}
          <div className="overflow-hidden w-[500px] h-[500px]">
            <img
              src={mainPassionImage} // Using the single imported image
              alt="Elizabeth Jacobs' coaching approach"
              className="w-full h-full object-cover rounded-full shadow-lg"
            />
          </div>
        </div>

        {/* Right Content */}
        <div className="lg:w-1/2 text-center lg:text-left">
          <h2 className="text-4xl md:text-5xl font-semibold leading-snug mb-6 text-[#3C2415]">
           Why Choose ATX Plant Rescue?
          </h2>

          <ul className="text-[#3C2415] list-disc list-inside text-lg md:text-lg mb-6 space-y-2">
            
            <li>Local Austin-based plant experts</li>
            <li>Friendly, approachable, and affordable care</li>
            <li>Customized solutions for your space and lifestyle</li>
            <li>Passionate about helping every plant live its best life</li>
          </ul>

          {/* The "More About Us" button might be less relevant for this section now, consider if it still fits. */}
          {/* For now, keeping it as it was in the original component, but you might want to change its text or remove it. */}
          <a href="https://book.squareup.com/appointments/xxgm3rjcbdu4ud/location/LC274M19X7T68/services">
          <button className="bg-[#1A3C34] w-full sm:w-auto px-6 py-2 sm:py-3 text-white text-[16px] font-semibold rounded-full hover:bg-[#2e5d50] transition-colors duration-300">
            Explore Our Services
          </button>
           </a>
        </div>
      </div>
    </section>
  );
}

export default Passion;